import * as M from '@/model';

export const SHORT_SUMMARY_THRESHOLD = 300;

export function isShortSummaryGroup(group: M.SummaryGroup): boolean {
  if (group.head) {
    return false;
  }
  const slices = group.specSlices || [];
  const chars = slices.map((s) => s.to - s.from).reduce((a, b) => a + b, 0);
  return chars <= SHORT_SUMMARY_THRESHOLD;
}

export function getTotalSliceChars(group: M.SummaryGroup): number {
  const slices = group.specSlices || [];
  return slices.map((s) => s.to - s.from).reduce((a, b) => a + b, 0);
}
